module.exports = __webpack_public_path__ + "img/moon-cloud-snow.58de9ef.svg";